import React from 'react';

/** The backend re-aggregates the live ("Today") range every ~5 minutes. */
export const LIVE_REFRESH_MS = 5 * 60 * 1000;

/**
 * A counter that increments every `stepMs` while `active`, otherwise frozen. Feed
 * it into a fetch effect's dependency array to re-dispatch the live request on a
 * cadence (the request key stays stable, so the refresh is stale-while-revalidate
 * — the cached figures stay on screen and update in place, no skeleton flash).
 */
export const useRefreshTick = (active: boolean, stepMs: number): number => {
  const [tick, setTick] = React.useState(0);
  React.useEffect(() => {
    if (!active) return undefined;
    const id = setInterval(() => setTick((t) => t + 1), stepMs);
    return () => clearInterval(id);
  }, [active, stepMs]);
  return tick;
};

export default useRefreshTick;
